/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { MODES } from 'src/theme';

const initialState = {
  themeMode: MODES.LIGHT,
  gridLoadTime: null, // When PageGrid data is loaded in ms after app loading (if PageGrid logDisplayTime == true)
  formDisplayTime: null, // When PageForm is displayed in ms after app loading (if PageForm logDisplayTime == true)
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setThemeMode: (state, { payload }) => {
      state.themeMode = payload;
    },
    setGridLoadTime: (state, { payload }) => {
      state.gridLoadTime = payload;
    },
    setFormDisplayTime: (state, { payload }) => {
      state.formDisplayTime = payload;
    },
  },
});

export const { setThemeMode, setGridLoadTime, setFormDisplayTime } = appSlice.actions;

export default appSlice.reducer;
